"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const constants_1 = require("@/common/constants");
const Resource_1 = require("@/common/Resource");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PlayerResource',
    props: {
        type: {
            type: String,
            required: true,
        },
        count: {
            type: Number,
            required: true,
        },
        production: {
            type: Number,
            required: true,
        },
        resourceProtection: {
            type: String,
            required: false,
            default: 'off',
        },
        productionProtection: {
            type: String,
            default: 'off',
        },
        value: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {};
    },
    methods: {
        showResourceValue() {
            const learnerModeOn = (0, PreferencesManager_1.getPreferences)().learner_mode;
            switch (this.type) {
                case Resource_1.Resource.STEEL:
                    return learnerModeOn || this.value > constants_1.DEFAULT_STEEL_VALUE;
                case Resource_1.Resource.TITANIUM:
                    return learnerModeOn || this.value > constants_1.DEFAULT_TITANIUM_VALUE;
                case Resource_1.Resource.HEAT:
                    return this.value > 0;
                default:
                    return false;
            }
        },
    },
    computed: {
        mainCSS() {
            return 'resource_item--' + this.type;
        },
        iconCSS() {
            return 'resource_icon--' + this.type;
        },
        productionSign() {
            if (this.production > 0)
                return '+';
            return '';
        },
        protectionIcon() {
            if (this.resourceProtection === 'on') {
                return 'shield_icon';
            }
            if (this.resourceProtection === 'half') {
                return 'shield_icon_half';
            }
            if (this.productionProtection === 'on') {
                return 'shield_icon';
            }
            return '';
        },
        showProductionProtectedIcon() {
            return this.productionProtection === 'on';
        },
        showResourceProtectionIcon() {
            return this.productionProtection === 'on' && this.resourceProtection !== 'off';
        },
        resourceTypeTooltip() {
            if (this.type === Resource_1.Resource.MEGACREDITS) {
                return this.$t('MegaCredits (M€)');
            }
            return this.$t(this.type.charAt(0).toUpperCase() + this.type.slice(1));
        },
        productionCountTooltip() {
            return this.$t('Production count');
        },
    },
});
